import { useContext, useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { UserContext } from '../Context/UserContext';
import { useDomain } from '../Context/DomainContext';
import { useToast } from '../Context/ToastContext';
import useAxiosCall from '../Hooks/useAxiosCall';
import usePermissions from '../Hooks/usePermissions';
import { decryptData } from '../Utilities/CryptoUtility';
import useAutoLogout from '../Hooks/useAutoLogout';
import useTranslations from '../Hooks/useTranslations';
import useNotifications from '../Hooks/useNotifications';
import { SecureStorage } from '../Utilities/StorageEncryption';

const ProtectedRoute = () => {
    useAutoLogout();
    const { user, signIn, signOut } = useContext(UserContext);
    const { hasDomain } = useDomain();
    const { showToast } = useToast();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const { makeApiCall } = useAxiosCall();
    const { fetchPermissions } = usePermissions();
    const { fetchTranslations } = useTranslations();
    const { fetchNotifications } = useNotifications();
    const redirectStarted = useRef(false);

    const handleApiCallSuccess = async ({ data }) => {
        let decryptedData = decryptData(data);
        signIn(decryptedData.user);
        setIsAuthenticated(true);
    };

    const goToLogin = () => {
        signOut();
        const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
        window.location.assign(`${base}/login`);
    };

    const handleApiCallError = (errorMessage) => {
        console.error('Authentication error:', errorMessage);
        if (redirectStarted.current) {
            return;
        }
        redirectStarted.current = true;
        if (errorMessage) {
            showToast(errorMessage, 'danger', 'top-center', false);
            setTimeout(goToLogin, 2500);
            return;
        }
        goToLogin();
    };

    useEffect(() => {
        if ((user.accountType == "Support" && hasDomain && SecureStorage.getItem('company') != null) || (user.accountType != "Support" && hasDomain) ) {
            fetchPermissions();
            fetchTranslations();
            fetchNotifications();
        }
        checkAuthentication();
    }, []);

    const checkAuthentication = async () => {
        try {
            const companyPrefix = SecureStorage.getItem('companyKey') || '';
            const url = companyPrefix ? `profile?companyPrefix=${encodeURIComponent(companyPrefix)}` : 'profile';
            await makeApiCall({
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
                requestType: 'GET',
                url: url,
            });
        } catch (error) {
            console.error('API call error:', error);
        }
    };

    return isAuthenticated ? <Outlet /> : null;
};

export default ProtectedRoute;
